import * as Yup from "yup";
export const validtionOfSubmit = Yup.array().of(
  Yup.object().shape({
    total_points: Yup.number()
      .required("Total points are required")
      .min(1, "Total points must be at least 1")
      // Add the test() to the total_points field
      .test(
        "points-match",
        "Total points must equal the sum of all question points",
        function (totalPoints) {
          const questions = this.parent.questions_attributes; // Access sibling field
          if (!questions || questions.length === 0) return true;

          const sum = questions.reduce(
            (acc, question) => acc + (question.points || 0),
            0
          );
          return sum === totalPoints;
        }
      ),
    questions_attributes: Yup.array()
      .of(
        Yup.object().shape({
          points: Yup.number()
            .required("Question points are required")
            .min(1, "Question points must be at least 1")
        })
      )
      .min(1, "At least one question is required")
  })
);
